module.exports = __webpack_public_path__ + "static/media/shadowz.01db82cd.png";